import client from './axiosInstance';

export const fetchMembersFilterList = async () => {
  return await client.get(`/members/base/members`);
};
